export const API_PATH_START = "/api/client/v1";

export const LANGUAGE_PATH_REGEX = /\/(?:en|nl)/;

export const liveChannelNames = ["CBeebies", "BBC Earth", "BBC Lifestyle"];

export const DEFAULT_HEADERS: HeadersInit = {
  "X-Path-Infra": "website",
};
